import { useMemo } from 'react'
import useTriggerHotkey from '@renderer/hooks/useTriggerHotkey'

import { buildTourSteps, type TourStepDescriptor } from './build-tour-steps'
import { useSidepanelSectionOrder, useSidepanelSide } from '../../atoms'

/**
 * The tour's ordered steps. Both the tour card and the sidepanel's dimming
 * state derive from this single hook, so a step index always means the same
 * step on both sides.
 */
export function useTourSteps(): Array<TourStepDescriptor> {
  const sectionOrder = useSidepanelSectionOrder()
  const side = useSidepanelSide()
  const triggerHotkey = useTriggerHotkey()

  return useMemo(() => buildTourSteps(sectionOrder, { side, triggerHotkey }), [sectionOrder, side, triggerHotkey])
}
